import React from 'react';
import { ImagePlus } from 'lucide-react';
import { AnswerQualityHint } from './AnswerQualityHint';

interface Step9Data {
  image_elements_include: string;
}

interface Step9ImageElementsProps {
  data: Step9Data;
  onChange: (data: Step9Data) => void;
}

export function Step9ImageElements({ data, onChange }: Step9ImageElementsProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2 flex items-center gap-2">
          <ImagePlus className="w-4 h-4" />
          Welke elementen passen bij jouw bedrijf?
        </label>
        <textarea
          value={data.image_elements_include}
          onChange={(e) => onChange({ ...data, image_elements_include: e.target.value })}
          rows={5}
          className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all text-lg resize-none"
          placeholder="Brood, ambachtelijk bakwerk, rustieke tafels, houten planken, meel, vers uit de oven, bakkers aan het werk, gezellige winkelinterieurs"
          autoFocus
        />
        <AnswerQualityHint length={data.image_elements_include.length} />
      </div>
    </div>
  );
}
